<template>
  <div class="error-container d-flex flex-column">
    <simple-header />
    <div class="error-content">
      <div class="row m-0">
        <div class="col-lg-4 image-col">
          <transition name="bounce" enter-active-class="bounceInLeft">
            <img
              v-if="showWithDelay"
              src="../assets/image/error_pages/401.png"
              alt="error"
            />
          </transition>
        </div>
        <transition name="bounce" enter-active-class="bounceInRight">
          <div v-if="showWithDelay" class="col-lg-8 text-col">
            <h1>Oops... There was a login error.</h1>
            <p>There is trouble in verifying your identity. Please clear your browser cache and retry. If you need to change your password, please visit
              <a :href="landingPageUrl" class="error-anchor"><strong>landing.autodesk.com</strong></a> and click on Password Management icon. If problem persists, please contact Service Desk.</p>
            <a class="error-btn" @click="navigateToLanding()" role="link"
              >GO TO LANDING PAGE</a
            >
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
require("vue2-animate/dist/vue2-animate.min.css");
import SimpleHeader from "../components/SimpleHeader";
export default {
  name: "error",
  data() {
    return {
      showWithDelay: false,
      landingPageUrl: LANDING_PAGE_URL
    };
  },
  components: {
    SimpleHeader
  },
  methods: {
    navigateToLanding(){
      location.href=this.landingPageUrl;
    }
  },
  mounted() {
    setTimeout(() => {
      this.showWithDelay = true;
    }, 500);
  }
};
</script>
<style scoped>
.error-container {
  position: absolute;
}
.error-anchor{
  color:#fff;

}
</style>



// WEBPACK FOOTER //
// src/components/LoginErrorPage.vue